import React, { useState } from 'react';

import ResetMyPassword from './ResetMyPassword';
import ResetPasswordFail from './ResetPasswordFail';
import ResetPasswordSuccess from './ResetPasswordSuccess';
import { SkinTheme } from '../../design/models/SkinTheme';
import { SkinThemeConsumer } from '../../shared/SkinThemeContext';

const RequestPasswordResetContainer = () => {
  const [resetPasswordSuccess, setResetPasswordSuccess] = useState<boolean>();

  return (
    <SkinThemeConsumer>
    {
      (themeOptions: SkinTheme) => (
        <div className="membership-content">
          {
            resetPasswordSuccess === undefined
            &&
            <ResetMyPassword
              onComplete={result => setResetPasswordSuccess(result) }
            />
          }
          {
            resetPasswordSuccess === true
            &&
            <ResetPasswordSuccess />
          }
          {
            resetPasswordSuccess === false
            &&
            <ResetPasswordFail />
          }
          </div>
      )
    }
    </SkinThemeConsumer>
  )
}

export default RequestPasswordResetContainer;
